export interface N5Entry {
  front: string
  kanji: string
  meaning: string
}

export const n5Words: N5Entry[] = [
  { front: '先生', kanji: 'せんせい', meaning: '老师' },
  { front: '食べる', kanji: 'たべる', meaning: '吃' },
  { front: '水', kanji: 'みず', meaning: '水' },
  { front: '猫', kanji: 'ねこ', meaning: '猫' },
  { front: '本', kanji: 'ほん', meaning: '书' },
  { front: '学校', kanji: 'がっこう', meaning: '学校' },
  { front: '来年', kanji: 'らいねん', meaning: '明年' },
  { front: '大きい', kanji: 'おおきい', meaning: '大的' },
  { front: '話す', kanji: 'はなす', meaning: '说、谈话' },
  { front: '天気', kanji: 'てんき', meaning: '天气' },
]
